
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here you can load your scenario parameters in JSON format into the simulator.`}</p>
    <p>{`For a concrete example of a Scenario JSON File you may export any of the predefined scenarios using "Export"
functionality in the simulator. For Scenario JSON File format reference, see JSON schema
`}<a parentName="p" {...{
        "href": "https://github.com/neherlab/covid19_scenarios/blob/master/schemas/Shareable.yml"
      }}>{`Shareable.yml`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;